export class ConversionError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'ConversionError'
  }
}

export class ParseError extends ConversionError {
  constructor(message: string) {
    super(message)
    this.name = 'ParseError'
  }
}

export class FormatError extends ConversionError {
  constructor(message: string) {
    super(message)
    this.name = 'FormatError'
  }
}

export class DetectionError extends ConversionError {
  constructor(message: string) {
    super(message)
    this.name = 'DetectionError'
  }
}
